import React from "react"

interface IProps {
  menuData: IMenuItem
}

import * as styles from "./index.module.scss"
import MenuLink from "@/components/header/menu/menu-link"

const StandardSubmenu: React.FC<IProps> = ({ menuData }) => {
  return (
    <div className={styles.standard}>
      <h5>
        <MenuLink link={menuData.link}>
          {menuData.name}
          <i className="iconfont icon-chevron_right_black_24dp" />
        </MenuLink>
      </h5>
      <ul>
        {menuData.submenu?.map(x => {
          return (
            <li key={x.name}>
              <MenuLink link={x.link} isSystemLink={x.isSystemLink}>{x.name}</MenuLink>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default StandardSubmenu
